<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="400px"
    @keyup:enter="submit()"
  >
    <template slot="dialogTitle">
      {{ text }}
    </template>

    <v-card-text v-if="subtext">
      {{ subtext }}
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="error"
        :loading="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        {{ ctaText }}
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import ContentDialog from '@/components/helpers/Dialog'

export default {
    name: 'ConfirmDeleteDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: 'Are you sure you want to delete this?'
      },
      subtext: {
        type: String,
        default: undefined
      },
      ctaText: {
        type: String,
        default: 'Yes, delete'
      },
      submitting: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      visible(value) {
        if (value) {
          window.addEventListener('keyup', this.eventListener)
        } else {
          window.removeEventListener('keyup', this.eventListener)
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.eventListener)
    },
    created() {
      let self = this

      this.eventListener = function (ev) {
        if (ev.key === 'Enter') {
          self.submit()
          return
        }

        if (ev.key === 'Escape') {
          this.modalVisible = false
        }
      }
    },
    methods: {
      submit() {
        this.$emit('confirmed')
      }
    }
  }
</script>

<style scoped>

</style>
